import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ServiceModel } from 'src/app/shared/models/service.model';
import { AddDeliveryService } from 'src/app/shared/services/add-delivery.service';
import { ProductModel } from '../../../shared/models/product.model';
import { FeedbackService } from '../../../shared/services';
import { UserService } from 'src/app/shared/services/user.service';
import { ContextModel } from 'src/app/shared/models';

@Component({
  selector: 'app-search-order',
  templateUrl: './search-order.component.html',
  styleUrls: ['./search-order.component.scss']
})
export class SearchOrderComponent implements OnInit {

  service: Array<any> = [];
  id = this.router.snapshot.params.id;
  serviceData: Array<ServiceModel> = [];
  loading = false;
  orderId: string;
  code: string;
  order: any;
  products: Array<ProductModel>;
  isPaid: boolean;
  errMessage = false;
  err = true;
  name = '';
  arr: Array<boolean> = [];
  valueBar = 50;
  valueChecking = false;
  idnpChecking: string;
  idnpTicketCheck: string;
  showNotCoincidingMessage = false;
  showCoincidingMessage = false;
  authIdn: string; 
  orderStatus: string;
  
  navList = [
    { url: '/public/add-delivery', translatedText: 'admin.add-delivery' },
    { url: '.', translatedText: 'Service Agency', link: '/public/add-delivery' }
  ];

  constructor(
    public router: ActivatedRoute, 
    public addDeliverySvc: AddDeliveryService, 
    public feedbackService: FeedbackService,
    private route: Router,
    private userService: UserService) { }

  ngOnInit(): void {
    this.listOfServices()
  }

  listOfServices(): void {
    this.addDeliverySvc.listServices().subscribe(res => {
      this.service = res;
      this.service.forEach((el) => {
        el.providerName === this.id ? this.serviceData = el.services : null;
      });
    });
  }

  activateItem( service: any, i: number): void {
    this.arr = [];
    this.errMessage = false;
    this.code = service.code;
    this.name = service.name;
    this.serviceData.forEach((el, index) => {
      if (this.serviceData.length > this.arr.length) {
        this.arr.push(false);
      }
    });

    this.arr[i] = true;
  }

  inputValue(value: string): void {
    this.orderId = value;
  }

  submit(): void {
    this.valueBar = 30;
    this.err = true;
    this.errMessage = false;
    this.loading = true;
  
    this.addDeliverySvc.searchOrder(this.orderId, this.code)
      .pipe(
        finalize(() => {
          this.valueBar = 100;
          setTimeout(() => {
            if (this.valueBar === 100) {
              this.valueChecking = true;
            }
            setTimeout(() => {
              this.loading = false;
              this.valueChecking = false;
              this.valueBar = 30;
            }, 30);
            this.handleOrderSearchResult();
          }, 30);
        })
      )
      .subscribe(
        res => {
          this.handleOrderSearchSuccess(res);
        },
        err => {
          this.handleOrderSearchError(err);
        }
      );
  }
  
  private handleOrderSearchResult(): void {
    if (this.idnpChecking !== this.idnpTicketCheck) {
      this.showNotCoincidingMessage = true;
      this.showCoincidingMessage = false;
    } else {
      this.showNotCoincidingMessage = false;
      this.showCoincidingMessage = true;
    }
  }
  
  private handleOrderSearchSuccess(res: any): void {
    this.order = res;
    this.orderStatus = res.ticket.status;
    this.products = res.serviceProvider.products;
    this.userService.contextIsSelected$.subscribe((context: ContextModel) => {
      this.idnpChecking = context?.identifier;
   });
   this.idnpTicketCheck = res.ticket.receiver.id;
   this.isPaid = res.ticket.isPaid;
   this.feedbackService.handleSuccess('success-found-order');
  }
  
  private handleOrderSearchError(err: any): void {
    this.order = null;
    this.errMessage = true;
    this.feedbackService.handleError(err);
    this.err = false;
  }
  

  delivery(): void {
    this.route.navigate(['/public/shipping'], {
      relativeTo: this.router,
      queryParams: {
        orderId: this.orderId,
        serviceId: this.code,
        isPaid: this.isPaid
      }
    });
  }
}